module.exports = __webpack_public_path__ + "img/11.e4047e66.jpg";